import { Beer } from 'lucide-react';

export default function AppLoading({ label = 'Je rondje staat zo klaar…' }) {
  return (
    <div className="bb-app-loading" role="status" aria-live="polite">
      <div className="bb-launch-icon"><Beer size={38} strokeWidth={1.8} /></div>
      <p className="mt-5 text-3xl font-black tracking-tight">Cuplio</p>
      <p className="mt-2 text-sm text-zinc-500 dark:text-zinc-400">{label}</p>
      <span className="bb-launch-progress" aria-hidden="true" />
    </div>
  );
}
